import useTheme from '@material-ui/core/styles/useTheme';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { makeStyles } from '@material-ui/styles';

export const useFetchingDataGridStyles = (loading: boolean) => {
  const { breakpoints, palette: themePalette } = useTheme();
  const isMobile = useMediaQuery(breakpoints.down('sm'));
  const isScreenMd = useMediaQuery(breakpoints.down('md'));

  const useStyles = makeStyles({
    root: {
      border: 'none',
      padding: isMobile ? '30px 0px' : 20,
      '& .MuiDataGrid-columnSeparator': {
        visibility: 'hidden',
      },
      '& .MuiDataGrid-columnHeaderTitleContainer': {
        padding: 0,
      },
      '& .MuiDataGrid-row': {
        cursor: 'pointer',
      },
      '& .MuiDataGrid-toolbarContainer': {
        justifyContent: isMobile ? 'center' : 'end',
        color: themePalette.text.secondary,
      },
      '& .MuiButton-label': {
        color: themePalette.text.secondary,
        fontSize: 0,
      },
      '& .MuiButton-iconSizeSmall > *:first-child': {
        fontSize: 26,
      },
      '& .MuiButton-startIcon': {
        margin: 0,
      },
      '& .MuiButton-endIcon': {
        margin: 0,
      },
      '& .MuiDataGrid-cell': {
        opacity: loading ? 0.25 : 1,
        lineHeight: isScreenMd ? '1.43 !important' : '',
      },
      '& .MuiDataGrid-cell:focus': {
        outline: 'none',
      },
      '& .MuiDataGrid-columnHeader:focus': {
        outline: 'none',
      },
      '& .MuiSelect-root': {
        paddingBlock: 0,
        paddingRight: 24,
      },
    },
  });

  const classes = useStyles();

  return { classes };
};
